import React, { useMemo } from 'react';
import '../styles/ITS.css';
import { translations } from '../translations';

const ITS = ({ language }) => {
  const t = translations[language];

  const systems = useMemo(() => [
    {
      icon: (
        <img 
          src={`${process.env.PUBLIC_URL}/assets/cctv icon.png`} 
          alt="CCTV Camera" 
          style={{ width: '24px', height: '24px', objectFit: 'contain' }}
          loading="lazy"
          decoding="async"
        />
      ),
      title: typeof t.its.systems.cctv === 'object' ? t.its.systems.cctv.heading : t.its.systems.cctv,
      description: typeof t.its.systems.cctv === 'object' ? t.its.systems.cctv.content : t.its.systems.cctvDesc,
      readMoreContent: typeof t.its.systems.cctv === 'object' ? t.its.systems.cctv.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"></path>
        </svg>
      ),
      title: typeof t.its.systems.atcc === 'object' ? t.its.systems.atcc.heading : t.its.systems.atcc,
      description: typeof t.its.systems.atcc === 'object' ? t.its.systems.atcc.content : t.its.systems.atccDesc,
      readMoreContent: typeof t.its.systems.atcc === 'object' ? t.its.systems.atcc.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"></path>
          <rect x="2" y="6" width="14" height="12" rx="2"></rect>
        </svg>
      ),
      title: typeof t.its.systems.vvd === 'object' ? t.its.systems.vvd.heading : t.its.systems.vvd,
      description: typeof t.its.systems.vvd === 'object' ? t.its.systems.vvd.content : t.its.systems.vvdDesc,
      readMoreContent: typeof t.its.systems.vvd === 'object' ? t.its.systems.vvd.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16.247 7.761a6 6 0 0 1 0 8.478"></path>
          <path d="M19.075 4.933a10 10 0 0 1 0 14.134"></path>
          <path d="M4.925 19.067a10 10 0 0 1 0-14.134"></path>
          <path d="M7.753 16.239a6 6 0 0 1 0-8.478"></path>
          <circle cx="12" cy="12" r="2"></circle>
        </svg>
      ),
      title: typeof t.its.systems.vms === 'object' ? t.its.systems.vms.heading : t.its.systems.vms,
      description: typeof t.its.systems.vms === 'object' ? t.its.systems.vms.content : t.its.systems.vmsDesc,
      readMoreContent: typeof t.its.systems.vms === 'object' ? t.its.systems.vms.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h.01"></path>
          <path d="M2 8.82a15 15 0 0 1 20 0"></path>
          <path d="M5 12.859a10 10 0 0 1 14 0"></path>
          <path d="M8.5 16.429a5 5 0 0 1 7 0"></path>
        </svg>
      ),
      title: typeof t.its.systems.ofc === 'object' ? t.its.systems.ofc.heading : t.its.systems.ofc,
      description: typeof t.its.systems.ofc === 'object' ? t.its.systems.ofc.content : t.its.systems.ofcDesc,
      readMoreContent: typeof t.its.systems.ofc === 'object' ? t.its.systems.ofc.readMoreContent : null
    }
  ], [t.its.systems]);

  const firstThreeSystems = systems.slice(0, 3);
  const lastTwoSystems = systems.slice(3, 5);

  return (
    <section id="its" className="its-section">
      <div className="container">
        <div className="its-content">
          <div className="section-header">
            <h2 className="section-title">{t.its.title}</h2>
            <h3 className="section-subtitle">{t.its.subtitle}</h3>
            <p className="section-description its-section-lead">
              {t.its.description} {t.its.descriptionReadMore}
            </p>
          </div>
          <div className="its-grid">
            {firstThreeSystems.map((system, index) => (
              <div key={index} className="its-card">
                <div className="its-icon">{system.icon}</div>
                <h4 className="its-title">{system.title}</h4>
                {(system.description || system.readMoreContent) && (
                  <p className="its-description">
                    {system.description}
                    {system.readMoreContent && (
                      <span className="its-description-more">{system.readMoreContent}</span>
                    )}
                  </p>
                )}
              </div>
            ))}
          </div>
          <div className="its-grid its-grid-centered">
            {lastTwoSystems.map((system, index) => (
              <div key={index + 3} className="its-card">
                <div className="its-icon">{system.icon}</div>
                <h4 className="its-title">{system.title}</h4>
                {(system.description || system.readMoreContent) && (
                  <p className="its-description">
                    {system.description}
                    {system.readMoreContent && (
                      <span className="its-description-more">{system.readMoreContent}</span>
                    )}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITS;
